// extracted by mini-css-extract-plugin
export default {"fadeInLeft":"AnimationLayout_fadeInLeft__xChUT","fadeInRight":"AnimationLayout_fadeInRight__8Ofio","fadeInUp":"AnimationLayout_fadeInUp__gWWrm"};